// Copyright (c) 2025 by Audere

import { Box, Typography } from "@mui/material";
import ConversationHeader from "./ConversationHeader";
import ConversationTasks from "./ConversationTasks";
import Messages from "./Messages";
import { createStyleSheet, globalStyles } from "../utils/styles";
import {
  GetConversationResponse,
} from "../features/api/labelApiSlice";
import EmptyPage from "../../assets/select_conversation.png";
import Breadcrumbs from "./Breadcrumbs";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useLocation } from "react-router-dom";

interface MainPanelProps {
  isLoading: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
  conversationMessages?: GetConversationResponse;
  convoIsLoading: boolean;
  convoError: FetchBaseQueryError | SerializedError | undefined;
}

const MainPanel: React.FC<MainPanelProps> = ({
  isLoading,
  error,
  conversationMessages,
  convoIsLoading,
  convoError
}) => {
  const isEditMode = useLocation().pathname.endsWith("/edit");

  return (
    <Box sx={styles.mainPanel}>
      <Breadcrumbs />
      {!isEditMode && !conversationMessages && (
        <Box sx={styles.imageBox}>
          <img
            src={EmptyPage}
            alt="Select a conversation"
            style={{ maxWidth: "50%" }}
          />
          <Box marginTop={2}>
            <Typography>
              Select a conversation on the left to view more information.
            </Typography>
          </Box>
        </Box>
      )}
      {!isEditMode && conversationMessages && (
        <>
          <Box sx={styles.convoHeaderBox}>
            <ConversationHeader
              conversation={conversationMessages}
              isLoading={isLoading}
              error={error}
            />
          </Box>
          <Box sx={styles.messagesTitle}>
            <Typography variant="h6">Conversation Messages</Typography>
          </Box>
          <Box sx={styles.messagesBox}>
            <Messages
              conversation={conversationMessages}
              isLoading={convoIsLoading}
              error={convoError}
            />
          </Box>
        </>
      )}

      {/* Conversation selected, edit mode, show tasks */}
      {isEditMode && (
        <Box sx={styles.tasksBox}>
          <ConversationTasks />
        </Box>
      )}
    </Box>
  );
};

const styles = createStyleSheet({
  mainPanel: {
    ...globalStyles.flexColumn,
    flex: 1,
    overflow: "hidden",
    padding: 3,
  },
  imageBox: {
    ...globalStyles.flexColumn,
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  convoHeaderBox: {
    flexShrink: 0,
    marginBottom: 2,
  },
  messagesTitle: {
    flexShrink: 0,
    marginBottom: 1,
  },
  messagesBox: {
    border: "2px solid lightgrey",
    borderRadius: 1.5,
    flex: 1,
    overflow: "auto",
  },
  tasksBox: {
    flex: 1,
    overflow: "auto",
  },
});

export default MainPanel;
